import {DeepPartial} from 'react-hook-form';

import {PostCorrectiveTaxDocumentForCreatingApiResponse} from '@dms/api/sales';

import {PERCENTAGE_SIGN} from '../../../constants';
import {AccountingDocumentFormValues} from '../../../types';

export const mapInvoiceItems = (
  items: NonNullable<PostCorrectiveTaxDocumentForCreatingApiResponse>['items'] | undefined
): DeepPartial<AccountingDocumentFormValues['invoiceItems']> => {
  if (!items) {
    return [];
  }

  return items.map((item) => ({
    description: item.name,
    isUnitPriceWithVat: item.isPriceUnitWithVat,
    itemId: item.invoiceItemId,
    type: item.type as AccountingDocumentFormValues['invoiceItems'][number]['type'],
    vatType: item.vatType as AccountingDocumentFormValues['invoiceItems'][number]['vatType'],
    quantity:
      item.type === 'discount' && item.unit === PERCENTAGE_SIGN
        ? (item.discount?.percent?.toString() ?? null)
        : (item.quantity?.toString() ?? null),
    pricePerUnit: item.pricePerUnit.toString(),
    relatedItemId: item.discount?.relatedInvoiceItemId ?? null,
    unit: item.unit,
    priceWithoutVat: item.priceWithoutVat.toString(),
    priceWithVat: item.priceWithVat.toString(),
  }));
};
